import { APIPresentationAssetAttributes } from '@ardoq/api-types';
import type { PresentationSlide } from 'components/presentationSidebar/types';
import { AppModules } from '../types';

type NewPresentationFormArgs = {
  selectedModule: AppModules;
  isCreatingNewPresentation: boolean;
};

export const isShowingNewPresentationForm = ({
  selectedModule,
  isCreatingNewPresentation,
}: NewPresentationFormArgs): boolean =>
  selectedModule === AppModules.PRESENTATIONS && isCreatingNewPresentation;

export type PresentationSidebarContent =
  | { type: 'nothing' }
  | { type: 'newPresentationForm' }
  | { type: 'presentation'; presentation: APIPresentationAssetAttributes };

type ResolveContentArgs = NewPresentationFormArgs & {
  presentation: APIPresentationAssetAttributes | undefined;
};

export const resolvePresentationSidebarContent = ({
  selectedModule,
  isCreatingNewPresentation,
  presentation,
}: ResolveContentArgs): PresentationSidebarContent => {
  if (
    isShowingNewPresentationForm({ selectedModule, isCreatingNewPresentation })
  )
    return { type: 'newPresentationForm' };
  if (!presentation) return { type: 'nothing' };
  return { type: 'presentation', presentation };
};

type ShownPresentation = {
  content: PresentationSidebarContent;
  slides: PresentationSlide[];
};

/** Keeps the closing presentation mounted, so it slides out with its content and focus can return from its close button. */
export const keepLastShownPresentation = <T extends ShownPresentation>(
  previous: T,
  next: T
): T => {
  if (
    next.content.type !== 'nothing' ||
    previous.content.type !== 'presentation'
  )
    return next;
  return { ...next, content: previous.content, slides: previous.slides };
};
